import { Tenant } from '@/types/common';
import { Option } from '@/types/components/common';

export const COUNTRY_FLAGS: Record<Tenant, string> = {
  [Tenant.Anguilla]: 'flag-anguilla',
  [Tenant.Barbados]: 'flag-barbados',
  [Tenant.BVI]: 'flag-british-virgin-islands',
  [Tenant.Dominica]: 'flag-dominica',
  [Tenant.Grenada]: 'flag-grenada',
  [Tenant.SaintLucia]: 'flag-saint-lucia',
  [Tenant.SaintKittsNevis]: 'flag-saint-kitts-and-nevis',
  [Tenant.SaintVincent]: 'flag-saint-vincent-and-the-grenadines',
  [Tenant.SintMaarten]: 'flag-sint-maarten',
  [Tenant.Guyana]: 'flag-guyana',
  [Tenant.Suriname]: 'flag-suriname',
  [Tenant.Trinidad]: 'flag-trinidad-and-tobago',
  [Tenant.Cayman]: 'flag-cayman-islands',
};

export const COUNTRY_PHONE_CODES: Record<Tenant, string> = {
  [Tenant.SaintKittsNevis]: '1869',
  [Tenant.Anguilla]: '1264',
  [Tenant.Barbados]: '1246',
  [Tenant.SaintLucia]: '1758',
  [Tenant.Dominica]: '1767',
  [Tenant.BVI]: '1284',
  [Tenant.Grenada]: '1473',
  [Tenant.SaintVincent]: '1784',
  [Tenant.SintMaarten]: '1721',
  [Tenant.Guyana]: '592',
  [Tenant.Suriname]: '597',
  [Tenant.Trinidad]: '1868',
  [Tenant.Cayman]: '1345',
};

export const COUNTRY_PHONE_CODES_ARRAY: Record<Tenant, string[]> = {
  [Tenant.SaintKittsNevis]: ['1869', '896'],
  [Tenant.Anguilla]: ['1264', '264'],
  [Tenant.Barbados]: ['1246', '246'],
  [Tenant.SaintLucia]: ['1758', '758'],
  [Tenant.Dominica]: ['1767', '767'],
  [Tenant.BVI]: ['1284', '284'],
  [Tenant.Grenada]: ['1473', '473'],
  [Tenant.SaintVincent]: ['1784', '784'],
  [Tenant.SintMaarten]: ['1721', '721'],
  [Tenant.Guyana]: ['592'],
  [Tenant.Suriname]: ['597'],
  [Tenant.Trinidad]: ['1868', '868'],
  [Tenant.Cayman]: ['1345', '345'],
};

export const CAYMAN_PHONE_CODES: Option[] = [
  { value: '1', text: '+1', icon: 'flag-united-states' },
  { value: '1', text: '+1', icon: 'flag-canada' },
  { value: '44', text: '+44', icon: 'flag-united-kingdom' },
  {
    value: '63',
    text: '+63',
    icon: 'flag-philippines',
  },
  {
    value: '1',
    text: '+1',
    icon: 'flag-jamaica',
  },
  { value: '', text: 'Others', icon: 'globe' },
];

export const CAYMAN_PHONE_DIGIT_LIMITS = {
  US: 10,
  CANADA: 10,
  JAMAICA: 10,
  PHILIPPINES: 10,
  UK: 11,
  OTHERS: 15,
};
